<template lang="html">
  <div class="invite">
    <div class="activityDesc" v-show="this.activityInfoData.type == 1" v-html="activityInfoData.activity_desc"></div>
    <div class="activityDesc" v-show="this.activityInfoData.type == 3" v-html="activityInfoData.help_desc"></div>

    <div class="footerBtn" :class="{elseFooterBtn: !activityInfoData.home_button_link}">
      <!-- <p class="iCloudBtn" v-show="activityInfoData.home_button_link" @click="getVisitor">
        <img :src="activityInfoData.home_button_img" alt="">
      </p> -->
      <p class="receiveAwardBtn" @click="getReceiveAward">{{assistanceText}}</p>
    </div>

    <!-- 登录框 -->
    <div class="logInCon" v-show="logInShow" @click.self="logInShow = false">
      <div class="userCon">
        <!-- 手机号 -->
        <input type="number" placeholder="请输入手机号" class="phoneInput" name="phoneInput" v-model="phone" @input="phoneInput">
        <!-- 验证码 -->
        <div class="securityCodeInput">
          <input type="text" placeholder="请输入验证码" name="securityCode" v-model="smsCode">
          <p class="getCode" :class="{checkValid: codeEnabled}" @click="getSmsCode">{{buttonMsg}}</p>
        </div>

        <div class="logInReceiveAwardBtn">
          <p>未注册的手机号登录后自动注册账号</p>
          <div class="beginBtn" :class="{loginCheckValid: loginEnabled}" @click="debouncedButtonClick">
            {{alsetAssistanceText}}
          </div>
        </div>
      </div>
    </div>

    <!-- 提示框 -->
    <div v-show="hintShow" class="hintMod">
      <p>{{hintCon}}</p>
    </div>
  </div>
</template>

<script>
  import Cookies from 'js-cookie';
  import utils from '@/utils/utils';
  import {pagebase} from '@/utils/http.js';
  import WxShare from '@/utils/wxshare';
  import { debounce } from 'lodash';

  export default {
    data() {
      return {
        pagebase: pagebase,
        assistanceText: '立即助力',
        activityId: this.$route.query.aid,
        inviteUid: this.$route.query.inviteUid,
        channelId: this.$route.query.channel || 0,
        iCloudBtnShow: true,
        activityInfoData: {},
        logInShow: false,
        phone: '',
        codeEnabled: false,
        smsCode: '',
        limitTime: 60,
        buttonMsg: '获取验证码',
        hintTime: 1,
        hintShow: false,
        hintCon: '',
        debouncedButtonClick: debounce(this.goLogin, 500),
        alsetAssistanceText: '立即助力',
      }
    },

    computed: {
      loginEnabled() {
        return this.phone && this.smsCode
      },
    },

    mounted() {
      this.init()
    },

    methods: {
      init() {
        this.getActivityInfo()
        this.getH5ActChannelStatRecord();
      },
      
      // 统计
      getH5ActChannelStatRecord() {
        this.$http({
          url: '/api/h5ActChannelStatRecord',
          method: 'post',
          params: {
            uid: Cookies.get('uid') || '',
            token: Cookies.get('token') || '',
            act_id: this.activityId,
            channel_id: this.channelId,
            type: 0,
          },
        })
      },

      getActivityInfo() {
        this.$http({
          url: '/api/getH5ActivityInfo',
          method: 'get',
          params: {
            uid: Cookies.get('uid') || '',
            token: Cookies.get('token') || '',
            activity_id: this.activityId,
            inviter_uid: this.inviteUid || '',
          },
        }).then((res) => {
          if (res.code >= 0) {
            this.activityInfoData = res.data;

            if (this.activityInfoData.is_invited) {
              this.assistanceText = '参与活动';
            }
            
            if (Cookies.get('uid') == this.inviteUid) {
              this.setHintCon('不允许本人助力，助力失败');
            }

            if(this.activityInfoData.is_max_invite_num) {
              this.setHintCon('邀请人数已达标，助力失败');
              this.assistanceText = '邀请人数已达标，去参与活动';
              this.alsetAssistanceText = '登录'
            }

            new WxShare().share({
              title: this.activityInfoData.title,
              desc: '邀请好友，分享得好礼，快来帮我助力',
              link: window.location.href,
              imgUrl: this.activityInfoData.cover,
            });

            
          }
        })
      },

      getVisitor() {
        window.location.href = this.activityInfoData.home_button_link;
      },

      // 领奖按钮
      getReceiveAward() {
        if (Cookies.get('uid') && Cookies.get('token')) {
          this.$http({
            url: '/api/h5ActivityRegister',
            method: 'post',
            params: {
              uid: Cookies.get('uid'),
              token: Cookies.get('token'),
              activity_id: this.activityId,
              channel_id: this.channelId,
            },
          }).then((res) => {
            if (res.code == -50) {
              this.logInShow = true;
            } else {
              if (this.activityInfoData.is_invited) {
                this.$router.push({
                  path: '/customActivityHome',
                  query: {
                    aid: this.activityId,
                    channel: this.channelId,
                  }
                })
              } else {
                this.$http({
                  url: '/api/assistanceH5Activity',
                  method: 'get',
                  params: {
                    uid: Cookies.get('uid'),
                    token: Cookies.get('token'),
                    inviter_uid: this.inviteUid,
                    activity_id: this.activityId,
                  },
                }).then((res) => {
                  if (res.code >= 0) {
                    this.setHintCon('助力成功');
                    this.getActivityRegister();
                  } else {
                    this.setHintCon(res.msg);
                  }

                  if (res.code == -999) {
                    this.$router.push({
                      path: '/customActivityHome',
                      query: {
                        aid: this.activityId,
                        channel: this.channelId,
                      }
                    })
                  }
                })
              }
            }
          })
        } else {
          this.logInShow = true;
        }
      },

      // 点击页面领取按钮
      getHtmlReceiveAward() {
        if (this.activityInfoData.type == 1) {
          if (this.activityInfoData.is_need_form) {
            if (this.activityInfoData.is_submit) {
              this.$router.push({
                path: '/customActivityInviteSucceed',
                query: {
                  aid: this.activityId,
                  channel: this.channelId,
                }
              })
            } else {
              this.$router.push({
                path: '/customActivityForm',
                query: {
                  aid: this.activityId,
                  channel: this.channelId,
                }
              })
            }
          } else {
            this.$router.push({
              path: '/customActivityInviteSucceed',
              query: {
                aid: this.activityId,
                channel: this.channelId,
              }
            })
          }
        } else if (this.activityInfoData.type == 3) {
          if (this.activityInfoData.is_need_form) {
            if (this.activityInfoData.is_submit) {
              this.$router.push({
                path: '/customActivityDetails',
                query: {
                  aid: this.activityId,
                  channel: this.channelId,
                }
              })
            } else {
              this.$router.push({
                path: '/customActivityForm',
                query: {
                  aid: this.activityId,
                  channel: this.channelId,
                }
              })
            }
          } else {
            this.$router.push({
              path: '/customActivityDetails',
              query: {
                aid: this.activityId,
                channel: this.channelId,
              }
            })
          }
        }
      },

      phoneInput(e) {
        let value = e.target.value
        this.codeEnabled = utils.checkPhone(value)
      },

      // 获取验证码
      getSmsCode() {
        if (this.codeEnabled || this.phone) {
          this.$http.get('/Registered/getPhoneSmsCode', {
            params: utils.cso({
              phone: this.phone,
              phone_head: 86,
              type: 10,
              client: 'H5'
            })
          }).then((res) => {
            if (res.code >= 0) {
              this.buttonMsg = this.limitTime + 's后重试'
              this.timer = window.setInterval(() => {
                this.limitTime--
                this.buttonMsg = this.limitTime + 's后重试'
                if (this.limitTime < 0) {
                  window.clearInterval(this.timer)
                  this.buttonMsg = '重新获取'
                  this.limitTime = 60
                }
              }, 1000)

              this.setHintCon('验证码发送成功');
            } else {
              this.setHintCon(res.msg);
            }
          })
        }
      },

      // 确定登录
      goLogin() {
        if (this.phone) {
          if (this.smsCode) {
            let body = {
              phone_head: 86,
              phone: this.phone,
              sms_code: this.smsCode,
              timestamp: new Date().getTime() / 1000,
              nonce: `${ Math.random().toString().slice(2) }${ this.smsCode }`,
            }

            Object.assign(body, {
              sign: utils.loginSign(body)
            })

            this.$http({
              url: '/Login/wxLogin',
              method: 'post',
              params: body,
            }).then((res) => {
              if (res.code >= 0) {
                this.$http({
                  url: '/api/assistanceH5Activity',
                  method: 'get',
                  params: {
                    uid: res.data.uid,
                    token: res.data.token,
                    inviter_uid: this.inviteUid,
                    activity_id: this.activityId,
                  },
                }).then((res) => {
                  
                  if (res.code >= 0) {
                    this.setHintCon('助力成功');
                  } else {
                    if (Cookies.get('uid') != this.inviteUid) {
                      this.setHintCon(res.msg);
                    }
                  }
                })
                
                this.getH5ActChannelStatRecord();
                
                this.getActivityRegister();

                Cookies.set('uid', res.data.uid, {
                  expires: 7
                });
                Cookies.set('token', res.data.token, {
                  expires: 7
                });

                this.logInShow = false;
              } else {
                this.setHintCon(res.msg)
              }
            })
          }
        }
      },

      // 参与活动
      getActivityRegister() {
        this.$http({
          url: '/api/h5ActivityRegister',
          method: 'post',
          params: {
            uid: Cookies.get('uid'),
            token: Cookies.get('token'),
            activity_id: this.activityId,
            channel_id: this.channelId,
          },
        }).then(() => {
          this.getActivityInfo();
        })
      },

      setHintCon(e) {
        window.clearInterval(this.timers)
        this.hintCon = e;
        this.hintShow = true;
        this.timers = window.setInterval(() => {
          this.hintTime--
          if (this.hintTime < 0) {
            window.clearInterval(this.timers)
            this.hintShow = false
            this.hintTime = 1
          }
        }, 1000)
      },
    }
  }
</script>

<style lang="css" scoped>
  .invite {
    box-sizing: border-box;
    width: 100%;
    background-size: 100% 82.1rem;
    background-repeat: no-repeat;
  }

  .activityDesc>>>img {
    width: 100% !important;
  }

  .footerBtn {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    padding: 0 1.5rem;
    padding-bottom: 3.4rem;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .elseFooterBtn {
    display: flex;
    justify-content: center;
  }

  .iCloudBtn {
    width: 16.3rem;
    height: 4.5rem;
    border-radius: 4.5rem;
    background: linear-gradient(to top, #FF6B0D, #FFC026);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.6rem;
    color: #FFFFFF;
  }

  .iCloudBtn img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4.5rem;
  }

  .receiveAwardBtn {
    width: 100%;
    height: 4.5rem;
    border-radius: 4.5rem;
    background: linear-gradient(to top, #EA1A14, #F7443F);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.6rem;
    color: #FFFFFF;
  }

  /* 登录框 */
  .logInCon {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 99;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .userCon {
    box-sizing: border-box;
    padding: 3.6rem 1.8rem;
    width: 32.5rem;
    height: 28.75rem;
    background-color: #FFFFFF;
    border-radius: 1.1rem;
  }

  .phoneInput {
    width: 100%;
    height: 4.7rem;
    border-radius: 4.7rem;
    border: none;
    background-color: #F5F5F7;
    box-sizing: border-box;
    padding: 0 1.5rem;
    font-size: 1.5rem;
    color: #333333;
    outline: none;
    margin-bottom: 1.5rem;
  }

  .phoneInput[name="phoneInput"]::-webkit-input-placeholder {
    color: #C0C4CC;
  }

  .securityCodeInput {
    display: flex;
    height: 4.7rem;
    margin-bottom: 3.05rem;
  }

  .securityCodeInput input {
    width: 65%;
    border-radius: 4.7rem 0 0 4.7rem;
    border: none;
    background-color: #F5F5F7;
    box-sizing: border-box;
    padding: 0 1.5rem;
    font-size: 1.5rem;
    color: #333333;
    outline: none;
  }

  .getCode {
    width: 35%;
    border-radius: 0 4.7rem 4.7rem 0;
    background-color: #F5F5F7;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 1.4rem;
    color: rgba(247, 68, 63, 0.5);
    padding-right: 2rem;
  }

  .checkValid {
    color: #F7443F;
  }

  .securityCodeInput input[name="securityCode"]::-webkit-input-placeholder {
    color: #C0C4CC;
  }

  .logInReceiveAwardBtn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .logInReceiveAwardBtn p {
    font-size: 1.3rem;
    color: #777777;
  }

  .beginBtn {
    width: 100%;
    height: 4.7rem;
    border-radius: 4.7rem;
    background: linear-gradient(to top, #FF8390, #FF8F90);
    margin-top: 0.75rem;
    font-size: 1.8rem;
    font-weight: 600;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .loginCheckValid {
    width: 100%;
    height: 4.5rem;
    line-height: 4.5rem;
    text-align: center;
    color: #FFFFFF;
    font-size: 1.6rem;
    font-weight: bolder;
    background: linear-gradient(#F7443F, #EA1A14);
    box-shadow: .1rem .5rem .6rem #FFD2D3;
  }

  /* 提示 */
  .hintMod {
    box-sizing: border-box;
    position: fixed;
    bottom: 45%;
    left: 0;
    display: flex;
    justify-content: center;
    width: 100%;
    z-index: 100;
  }

  .hintMod p {
    box-sizing: border-box;
    padding: 0 1.5rem;
    background-color: rgba(0, 0, 0, 0.5);
    font-size: 1.3rem;
    color: #FFFFFF;
    max-width: 65%;
    height: 4rem;
    border-radius: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>